'use client'
import React, { FC } from 'react'
import { Icon, IconButton, IconButtonProps } from '@chakra-ui/react'
import { CgPrinter } from 'react-icons/cg'

interface PrintButtonProps extends Partial<IconButtonProps> {}

const PrintButton: FC<PrintButtonProps> = ({ ...props }) => {
  return (
    <IconButton
      aria-label="share"
      borderColor="primary"
      minW="auto"
      borderWidth={1}
      boxSize={8}
      onClick={() => window.print()}
      icon={<Icon as={CgPrinter} boxSize={4} />}
      {...props}
    />
  )
}

export default PrintButton
